import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { getApiUrl } from '../../config/api';

const SystemMetrics = () => {
  const { user } = useAuth();
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchSystemMetrics();
    }
  }, [user]);

  const fetchSystemMetrics = async () => {
    try {
      if (!user) {
        console.error('User not authenticated');
        return;
      }
      const token = await user.getIdToken();
      const response = await fetch(getApiUrl('/api/admin/analytics/system-metrics'), {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setMetrics(data);
      }
    } catch (error) {
      console.error('Error fetching system metrics:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="system-metrics">
        <div className="loading-container">
          <p>Loading system metrics...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="system-metrics">
      <h2>System Metrics</h2>
      <p>System performance monitoring dashboard - coming soon!</p>
      {metrics && (
        <pre>{JSON.stringify(metrics, null, 2)}</pre>
      )}
    </div>
  );
};

export default SystemMetrics;
